import { Link } from 'react-router-dom';

const IndustrialCTA = () => {
  return (
    <section className="py-20 bg-navy">
      <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center">
        <h2 className="text-4xl font-bold text-white mb-6">
          Industrial Electrical Solutions You Can Trust
        </h2>
        <p className="text-gray-300 text-lg leading-relaxed mb-10">
          NS Electrical WA delivers industrial-grade electrical services with uncompromising standards for safety, compliance and operational reliability. Contact us for expert industrial electrical solutions.
        </p>
        <div className="flex flex-wrap items-center justify-center gap-4">
          <Link
            to="/contact"
            className="inline-flex items-center gap-2 bg-gold text-navy px-8 py-4 rounded-lg font-bold text-sm tracking-wider hover:bg-gold/90 transition-all whitespace-nowrap cursor-pointer"
          >
            REQUEST A QUOTE
          </Link>
          <a
            href="tel:0412345678"
            className="inline-flex items-center gap-2 border-2 border-gold text-gold px-8 py-4 rounded-lg font-bold text-sm tracking-wider hover:bg-gold hover:text-navy transition-all whitespace-nowrap cursor-pointer"
          >
            <i className="ri-phone-line text-xl w-5 h-5 flex items-center justify-center"></i>
            CALL NOW
          </a>
        </div>
      </div>
    </section>
  );
};

export default IndustrialCTA;